module.exports = __webpack_public_path__ + "img/tmf-login-v2.c18c943b.png";